export const isShouldLoadKatex = () =>
    typeof window !== 'undefined' &&
    // @ts-ignore
    typeof window.katex === 'undefined';
